export default __webpack_public_path__ + "static/turntable-a88424ec677edce36c68988180db8c82.mp4";